import { FETCH_REQUEST } from '../../sharedTypes';
import { LOGIN_ADMIN } from '../../fetchTypes';

export const loginRequest = data => ({
  type: FETCH_REQUEST,
  fetchType: LOGIN_ADMIN,
  data,
});
